import { gql } from "apollo-boost"

export default gql`
  mutation UpdateUserProfile($input: UserProfileInput!) {
    updateUserProfile(input: $input) {
      user {
        id
      }
      token
    }
  }
`
